import type { ImportMetaLocation } from "@-/dev.improve.haniverse.lib.logger";
import { createStaticFindFirstQuery } from "#create-static-find-first-query";
import { createStaticFindManyQuery } from "#create-static-find-many-query";
import type { StaticQueryTable } from "#types";

export function createStaticTableQueries<TTable extends StaticQueryTable>(
  location: ImportMetaLocation,
  table: TTable,
) {
  return {
    findFirst: createStaticFindFirstQuery(location, table),
    findMany: createStaticFindManyQuery(location, table),
  };
}
